import {UserConfig} from "../../types/UserConfig";
import ZenDesk from "./zendesk";
import {AccountStore} from "../../account/store/AccountStore";
import {isNotNull} from "../../js/util/UtilFunctions";

export class ZenDeskService {

    public static readonly id = "zenDeskService";

    /** @ngInject */
    public constructor(private readonly userConfig: UserConfig,
                       private readonly accountStore: AccountStore) {
    }

    public startZenDesk() {
        if (this.userConfig.branding === "OPEN_TRADER") {
            const s = ZenDesk("ad13ae26-a339-43ee-a68b-6a76b6a3770e");
            s.addEventListener("load", () => {
                const zE = (window as any).zE as any;
                const identityData = {
                    name: this.userConfig.shortName,
                    email: this.userConfig.username
                };

                zE("webWidget", "identify", identityData);

                const prefillData = {
                    name: {
                        value: this.userConfig.shortName,
                        readOnly: true // optional
                    },
                    email: {
                        value: this.userConfig.username,
                        readOnly: true // optional
                    }
                };

                zE("webWidget", "prefill", prefillData);

                this.accountStore
                    .current
                    .filter(isNotNull)
                    .map((account) => account.number)
                    .distinctUntilChanged()
                    .subscribe((accountNumber) => {
                        const zESettings = {
                            webWidget: {
                                contactForm: {
                                    fields: [
                                        {
                                            id: 360000160896,
                                            prefill: {"*": accountNumber}
                                        }
                                    ]
                                }
                            }
                        };
                        // (window as any).zE("webWidget", "clear");
                        (window as any).zE("webWidget", "updateSettings", zESettings);
                    });
            });
        }
    }
}
